module.exports = __webpack_public_path__ + "static/bottom-4b1a5feeb7512625bea846261bda8845.svg";